// Layouts
import FullPageMessage from "layouts/FullPageMessage";

// Components
import { Loader } from "@octopus-investments/deep-sea-components";

// Styles
import "./LoadingPage.scss";

export default function Loading({ title, content }) {
  return (
    <FullPageMessage smaller>
      <div className="loading-content">
        {title && <h1 className="coheadline navyBlue">{title}</h1>}
        <p className="loader-and-copy">
          <Loader className="loader-and-copy-content" size="lg" />
          <div className="loader-and-copy-content">{content}</div>
        </p>
      </div>
    </FullPageMessage>
  );
}
